"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DismissIcon = function DismissIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "14",
    role: "presentation",
    viewBox: "0 0 14 14",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.71094 7L13.1016 12.3984L12.3984 13.1016L7 7.71094L1.60156 13.1016L0.898438 12.3984L6.28906 7L0.898438 1.60156L1.60156 0.898438L7 6.28906L12.3984 0.898438L13.1016 1.60156L7.71094 7Z"
  }));
};

DismissIcon.defaultProps = {
  className: undefined
};
DismissIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = DismissIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEaXNtaXNzSWNvbiIsImNsYXNzTmFtZSIsImRlZmF1bHRQcm9wcyIsInVuZGVmaW5lZCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsInN0cmluZyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL1RvYXN0L0Rpc21pc3NJY29uLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBEaXNtaXNzSWNvbiA9ICh7IGNsYXNzTmFtZSB9KSA9PiAoXG4gIDxzdmdcbiAgICBjbGFzc05hbWU9eyhjbGFzc05hbWUgfHwgJycpICsgJyd9XG4gICAgZm9jdXNhYmxlPXtmYWxzZX1cbiAgICBoZWlnaHQ9XCIxNFwiXG4gICAgcm9sZT1cInByZXNlbnRhdGlvblwiXG4gICAgdmlld0JveD1cIjAgMCAxNCAxNFwiXG4gICAgd2lkdGg9XCIxNFwiXG4gICAgeG1sbnM9XCJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gID5cbiAgICA8cGF0aCBkPVwiTTcuNzEwOTQgN0wxMy4xMDE2IDEyLjM5ODRMMTIuMzk4NCAxMy4xMDE2TDcgNy43MTA5NEwxLjYwMTU2IDEzLjEwMTZMMC44OTg0MzggMTIuMzk4NEw2LjI4OTA2IDdMMC44OTg0MzggMS42MDE1NkwxLjYwMTU2IDAuODk4NDM4TDcgNi4yODkwNkwxMi4zOTg0IDAuODk4NDM4TDEzLjEwMTYgMS42MDE1Nkw3LjcxMDk0IDdaXCIgLz5cbiAgPC9zdmc+XG4pO1xuXG5EaXNtaXNzSWNvbi5kZWZhdWx0UHJvcHMgPSB7XG4gIGNsYXNzTmFtZTogdW5kZWZpbmVkXG59O1xuXG5EaXNtaXNzSWNvbi5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZ1xufTtcblxuZXhwb3J0IGRlZmF1bHQgRGlzbWlzc0ljb247XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7OztBQUVBLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjO0VBQUEsSUFBR0MsU0FBSCxRQUFHQSxTQUFIO0VBQUEsb0JBQ2xCO0lBQ0UsU0FBUyxFQUFFLENBQUNBLFNBQVMsSUFBSSxFQUFkLElBQW9CLEVBRGpDO0lBRUUsU0FBUyxFQUFFLEtBRmI7SUFHRSxNQUFNLEVBQUMsSUFIVDtJQUlFLElBQUksRUFBQyxjQUpQO0lBS0UsT0FBTyxFQUFDLFdBTFY7SUFNRSxLQUFLLEVBQUMsSUFOUjtJQU9FLEtBQUssRUFBQztFQVBSLGdCQVNFO0lBQU0sQ0FBQyxFQUFDO0VBQVIsRUFURixDQURrQjtBQUFBLENBQXBCOztBQWNBRCxXQUFXLENBQUNFLFlBQVosR0FBMkI7RUFDekJELFNBQVMsRUFBRUU7QUFEYyxDQUEzQjtBQUlBSCxXQUFXLENBQUNJLFNBQVosR0FBd0I7RUFDdEJILFNBQVMsRUFBRUksa0JBQUEsQ0FBVUM7QUFEQyxDQUF4QjtlQUllTixXIn0=